import { Odds, OddsOperations } from '@frontend/sports/odds/feature';
import { PlacementErrorType } from '@frontend/sports/types/betslip';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';

import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { BetslipError } from '../betslip-error';
import { NotifyUserErrorMixin } from '../notify-user-error';
import { ResultError } from './result-error';

export class OddsChanged extends NotifyUserErrorMixin<ResultError>(ResultError) {
    constructor(
        pickId: string,
        public currentOdds: Odds,
        public expectedOdds: Odds,
        public oddsFormat: OddsDisplayFormat,
    ) {
        super(pickId);
        this.priority = -998;

        this.hasClientValidation = true;
        this.type = PlacementErrorType.OddsChanged;
        this.icon = BetPlacementErrorIcon.Warning;
    }

    override equals(error: BetslipError): boolean {
        if (error instanceof OddsChanged && this.currentOdds != null && this.expectedOdds != null) {
            return (
                this.pickId === error.pickId &&
                OddsOperations.equal(this.currentOdds, error.currentOdds, OddsOperations.convertToBposOddsFormat(this.oddsFormat)) &&
                OddsOperations.equal(this.expectedOdds, error.expectedOdds, OddsOperations.convertToBposOddsFormat(this.oddsFormat))
            );
        }

        return super.equals(error);
    }
}
